/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Aporbo's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Aporba Ghosh Portfolio",
    type: "website",
    url: "aporbo.com",
  },
};

//Home Page
const greeting = {
  title: "Aporba Ghosh",
  logo_name: "Aporba Ghosh",
  nickname: "Tech Virtuoso",
  subTitle:
    "A passionate Tech Explorer: Bridging Innovation through Code, AI, and Intuitive Design",
  resumeLink:
    "https://drive.google.com/drive/folders/1R-gkiYLW1vToG7Flk0EljA_-CHZGLc-y?usp=sharing",
  portfolio_repository: "https://github.com/Aporbo?tab=repositories",
  githubProfile: "https://github.com/Aporbo",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/Aporbo",
  // linkedin: "https://www.linkedin.com/in/Aporbo-hathidara-88710b138/",
  // gmail: "Aporbohathidara98@gmail.com",
  // gitlab: "https://gitlab.com/Aporbohathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/Aporbo_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Aporbo",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/Aporbo/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
 
  {
    name: "Gmail",
    link: "mailto:aporbogosh249@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  
  {
    name: "Facebook",
    link: "https://www.facebook.com/Aporbo_The_Ghosh/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/aporbo_the_ghosh/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Creating application backend in Node and Express ",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "fa-node-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
       
        
      ],
    },
    {
      title: "Machine Learing and AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Experiencing scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experiencing Computer Vision and NLP",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        
      ],
      softwareSkills: [
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
      
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/aporba/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/aporbo_ghosh",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/aporbo112",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/Aporbo",
    },
   
  ],
};

const degrees = {
  degrees: [
    {
      title: "North South University",
      subtitle: "BSC in Computer Science and Engineering",
      logo_path: "nsu_logo.png",
      alt_name: "NSU",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
      ],
      website_link: "https://www.northsouth.edu/",
    },
    
  ],
};

const certifications = {
  certifications: [
    {
      title: "Full stack Web Development",
      subtitle: " Programming Hero",
      logo_path: "ph_logo.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1kcITYGYxpAoqRWcliVtaWs5LE2Bep0MI/view?usp=sharing",
      alt_name: "Ph-Batch-3",
      color_code: "#8C151599",
    },
    {
      title: "Negotiation",
      subtitle: "Skills And Strategies For Negotiation",
      logo_path: "bylc_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/15TsSGrLW2ziE2gblx14F9_y8D04xlaUh/view?usp=sharing",
      alt_name: "Negotiation",
      color_code: "#00000099",
    },
    
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "In various roles, including work, internships, and volunteer positions, I've gained valuable experience. Whether as a junior developer at a startup or as a sub-executive at the ACM Student Chapter, I've been actively involved in diverse tasks, contributing to projects, conducting research, and developing negotiation skills in an international context. These experiences have collectively shaped my professional growth, providing insights into dynamic work environments and fostering a continuous learning mindset.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Sub-Executive",
          company: "NSU ACM STUDENT CHAPTER",
          company_url: "https://nsusc.acm.org/",
          logo_path: "acm_logo.png",
          duration: "Sep 2020 - Aug 2023",
          location: "Dhaka, Bangladesh",
          description:
            " NSUACM student chapter provide a range of benefits to the members, including networking opportunities, access to resources such as research papers and publications, and opportunities to participate in competitions and other events related to computer science. NSUACMSC also offers a platform for engineering students to engage with professionals in the industry, learn about emerging technologies and trends, and develop skills and knowledge.I joined NSUAMCSC in Fall 2019 as a corporate team member and learned a lot of corp and industry things which I never can learnt without NSUACMSC. I am learning how to manage a organization which will help me in future when i will be responsible by my own. I got so much potential people through this organization. Surviving at NSU without ACMSC wouldn't be so easy for me without the people and leaning from NSUACMSC By joining an ACM student chapter, I enhanced my academic and professional experience, connect with like-minded individuals, and develop leadership and teamwork skills. The organization also plays a vital role in promoting computer science education.",
          color: "#4285F4",
        },
        
      ],
    },
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Junior Developer",
          company: "Zealtech BD",
          company_url: "https://www.zealtechbd.com/",
          logo_path: "Zealtechbd-logo.png",
          duration: "June 2022 - Nov 2022",
          location: "Dhaka, Bangladesh",
          description:
            "As a junior developer at a startup, I contributed to software development projects, collaborating with a diverse team. My responsibilities included coding, debugging, and testing, fostering a dynamic and innovative work environment. This experience enhanced my skills and provided valuable insights into the fast-paced tech industry.",
          color: "#0879bf",
        },
        
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Intern Developer",
          company: "Zealtech BD",
          company_url: "https://www.zealtechbd.com/",
          logo_path: "Zealtechbd-logo.png",
          duration: "Feb 2022 - May 2022",
          location: "Dhaka, Bangladesh",
          description:
            "As a startup intern, I contributed to diverse tasks, including projects and research, gaining valuable hands-on experience in a dynamic environment. This opportunity provided practical insights into the startup culture, fostering professional growth.",
          color: "#000000",
        },
      ],
    },
    
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "In my experience, I've undertaken a variety of projects, demonstrating proficiency across different technologies, including C, C++, Java, JavaScript, React, and Node.js. Noteworthy among these is a machine learning project focused on food detection, highlighting my ability to explore innovative solutions in diverse domains.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "",
      name: "working on it",
      createdAt: "",
      description: "",
      url:
        "",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Aporbo.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android and Development.",
  },
  
  addressSection: {
    title: "Address",
    subtitle:
      "Bashundhara Residential Area, Dhaka, Bangladesh",
    locality: "Bangladeshi",
    country: "Bangladesh",
    region: "Dhaka",
    postalCode: "2300",
    streetAddress: "Afroza begom Road",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/R5BNDnaP5E8ADKEX6",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+8801799889888",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
